import React, { memo, useEffect, useRef, useState } from 'react'
import cogoToast from 'cogo-toast-react-17-fix';

import API from '../../../../ApiConfig'
import { GET_COMPANY_LIST } from '../../../../Utils/constant'
import styles from '../Verifier/VerifyUsers.module.css'
import { _ToNormal } from '../../../../Utils/helper';
import { MESSAGE } from '../../../../Utils/Strings';


export default function CompanySearch({ setOnBehalf, onBehalf,setOther, other }) {
    const [loading, setLoading] = useState(false)

    const [companyList, setCompanyList] = useState([])
    const [word, setWord] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [wordList, setwordList] = useState(false)

    const dialogBox = useRef(null);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (word.length < 1) {
            setOnBehalf(null)
        }
        if (!word) return;
        const handler = setTimeout(() => {
            getAllCompany(word);
        }, 500);

        return () => clearTimeout(handler);
    }, [word])

    async function getAllCompany(word) {
        setLoading(true)
        API.get(GET_COMPANY_LIST + '?name=' + word)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    if (!wordList) {
                        setIsOpen(true)
                    }
                    else {
                        setwordList(false)
                    }
                    if ((res.data.data).length > 0) {
                        setCompanyList(res.data.data)
                    }
                    else {
                        setCompanyList([
                            {
                                "company_id": null,
                                "company_name": "No Issuer found"
                            }
                        ])
                    }
                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
            })
    }

    const setWordFromList = (i) => {
        setOnBehalf(i)
        setWord(i.company_name)
        setIsOpen(false)
        setwordList(true)
    }

    return (
        <div>
        <div className={styles.MainSearchContainer}>
            <h2 className='topTitleBarText' style={{ width: '8rem' }}>
                On behalf of:<span style={{ color: 'red' }}>*</span>
            </h2>
            <div className={styles.selectdocument}>
                <div className={styles.letter} ref={dialogBox} style={{ width: '30rem' }}>
                    <div className={styles.lettertype} style={{ cursor: "pointer" }}>
                        <input value={word} placeholder={MESSAGE.PLACEHOLDER} onChange={e => setWord(e.target.value)} className={styles.selectItem} />
                    </div>
                    <div className={styles.customDropdown} style={{ width: "inherit" }}>
                        {isOpen && (
                            <div className={styles.dropdownOptions} style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
                                {companyList.map((i) => (
                                    <div key={i.company_id} className={styles.dropdownList} onClick={() => { i.company_id ? setWordFromList(i) : null }}>
                                        {i.company_name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div >
        {word=="OTHERS" && !isOpen &&
        <div className={styles.MainSearchContainer}>
            <h2 className='topTitleBarText' style={{ width: '8rem' }}>OTHERS: <span style={{color:"red"}}>*</span></h2>
            <div className={styles.selectdocument}>
            <div className={styles.letter}>
            <input type='text' className={styles.input} value={other} style={{ width: '29rem' }} placeholder='Enter Others' onChange={(e)=>setOther(e.target.value)}/>
            </div>
            </div>
        </div>}
        </div>
    )
}